import React from "react";
import Rating from "@mui/material/Rating";
import { Box,Typography } from "@mui/material";


const RatingMUI = ({ value }) => {
  return (
    <Box sx={{display:"flex", gap:1}}>
      <Rating
        name="half-rating-read"
        defaultValue={value}
        precision={0.5}
        readOnly
        sx={{
          "& .MuiRating-iconHalf": {
            border: "1px solid white",
            backgroundColor: "rgba(255, 255, 255, 0.5)", 
          },
        }}
      />
      {/* <Typography>{value}</Typography> */}
    </Box >
  );
};

export default RatingMUI;
